import React, { useEffect, memo, Fragment, useState } from "react";
import { Row, Col, Dropdown, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { message, Popover, Tooltip, Table, Tag } from "antd";
import axios from "axios";
import { FaUsers, FaUser, FaApple, FaBan } from "react-icons/fa";
import {
  MdWorkspacePremium,
  MdOutlineVerified,
  MdReport,
  MdOnlinePrediction,
  MdOutlineDeleteSweep,
} from "react-icons/md";
import { TbRadioactiveFilled } from "react-icons/tb";
import { IoLogoAndroid } from "react-icons/io";
import { VscUnverified } from "react-icons/vsc";
import { RxCrossCircled } from "react-icons/rx";

//circular
import Circularprogressbar from "../../components/circularprogressbar.js";

// AOS
import AOS from "aos";
import "../../../node_modules/aos/dist/aos";
import "../../../node_modules/aos/dist/aos.css";

//swiper
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation } from "swiper";

// Import Swiper styles
import "swiper/swiper-bundle.min.css";
// import 'swiper/components/navigation/navigation.scss';

//Count-up
import CountUp from "react-countup";

// Redux Selector / Action
import { useSelector } from "react-redux";

// Import selectors & action from setting store
import * as SettingSelector from "../../store/setting/selectors";
import { SERVER_ADDRESS } from "../../Config/Config.js";
import PieChart from "./PieChart.js";

// install Swiper modules
SwiperCore.use([Navigation]);

const columns = [
  {
    title: "Id",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Gender",
    key: "gender",
    render: (_, record) =>
      record.gender === "1" ? (
        <Tag color="blue">Groom</Tag>
      ) : (
        <Tag color="magenta">Bride</Tag>
      ),
  },
  {
    title: "State",
    key: "state",
    render: (_, record) => {
      const text = `${record.city || ""}, ${record.state || ""}`;
      const displayText = text.length > 10 ? text.slice(0, 10) + "..." : text;

      return text.length > 10 ? (
        <Tooltip title={text}>
          <span>{displayText}</span>
        </Tooltip>
      ) : (
        <span>{displayText}</span>
      );
    },
  },
  {
    title: "Account",
    key: "is_premium",
    render: (_, record) =>
      record.is_premium === 1 ? (
        <Tag color="warning">Premium</Tag>
      ) : (
        <Tag color="default">Normal</Tag>
      ),
  },
];

const Index = memo((props) => {
  useSelector(SettingSelector.theme_color);

  const [users, setUsers] = useState([]);
  const [statistic, setSatistic] = useState({});
  const [loading, setLoading] = useState(true);
  const [spinner, setSpinner] = useState(true);

  const fetchRecentUsers = async () => {
    try {
      const response = await axios.post(`${SERVER_ADDRESS}/api/recentUsers`, {
        type: "2",
      });

      if (users.length === 0 && response.status === 200) {
        setUsers(response.data.data);
      }
    } catch (error) {
      console.log(error);
      message.error({ content: "Internal Server error", duration: 200 });
    }
  };

  const fetchStatistics = async () => {
    try {
      const response = await axios.post(`${SERVER_ADDRESS}/api/recentUsers`, {
        type: "1",
      });
      const result = response.data.data;
      setLoading(false);
      setSatistic(result);
      setSpinner(false);
    } catch (error) {
      console.log(error);
      message.error({ content: "Something Went Wrong", duration: 2 });
    }
  };

  useEffect(() => {
    fetchRecentUsers();
    fetchStatistics();
  }, []);

  const getVariableColor = () => {
    let prefix =
      getComputedStyle(document.body).getPropertyValue("--prefix") || "bs-";
    if (prefix) {
      prefix = prefix.trim();
    }
    const color1 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}primary`
    );
    const color2 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}info`
    );
    const color3 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}primary-tint-20`
    );
    const color4 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}warning`
    );
    return {
      primary: color1.trim(),
      info: color2.trim(),
      warning: color4.trim(),
      primary_light: color3.trim(),
    };
  };
  const variableColors = getVariableColor();

  const colors = [variableColors.primary, variableColors.info];
  useEffect(() => {
    return () => colors;
  });

  useEffect(() => {
    AOS.init({
      startEvent: "DOMContentLoaded",
      disable: function () {
        var maxWidth = 996;
        return window.innerWidth < maxWidth;
      },
      throttleDelay: 10,
      once: true,
      duration: 700,
      offset: 10,
    });
  });

  return (
    <Fragment>
      <Row>
        {/* Users statistics */}
        <Col md="12" lg="12">
          <Row className="row-cols-1">
            <div className="overflow-hidden d-slider1 ">
              <Swiper
                className="p-0 m-0 mb-2 list-inline "
                slidesPerView={5}
                spaceBetween={32}
                navigation={{
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                }}
                breakpoints={{
                  320: { slidesPerView: 1 },
                  550: { slidesPerView: 2 },
                  991: { slidesPerView: 3 },
                  1400: { slidesPerView: 3 },
                  1500: { slidesPerView: 4 },
                  1920: { slidesPerView: 4 },
                  2040: { slidesPerView: 7 },
                  2440: { slidesPerView: 8 },
                }}
              >
                <SwiperSlide className="card card-slide">
                  <div className="card-body">
                    <div className="progress-widget">
                      <Circularprogressbar
                        stroke={variableColors.primary}
                        width="60px"
                        height="60px"
                        Linecap="rounded"
                        trailstroke="#ddd"
                        strokewidth="4px"
                        style={{ width: 60, height: 60 }}
                        value={100}
                        id="circle-progress-01"
                      >
                        <FaUsers size={30} />
                      </Circularprogressbar>
                      <div className="progress-detail">
                        <p className="mb-2">Total Users</p>
                        <h4 className="counter">
                          <CountUp
                            start={0}
                            end={statistic.totalUser || 0}
                            duration={1}
                          />
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide className=" card card-slide">
                  <div className="card-body">
                    <div className="progress-widget">
                      <Circularprogressbar
                        stroke={variableColors.info}
                        width="60px"
                        height="60px"
                        trailstroke="#ddd"
                        strokewidth="4px"
                        Linecap="rounded"
                        style={{ width: 60, height: 60 }}
                        value={100}
                        id="circle-progress-02"
                      >
                        <FaUser size={30} />
                      </Circularprogressbar>
                      <div className="progress-detail">
                        <p className="mb-2">Normal Users</p>
                        <h4 className="counter">
                          <CountUp
                            start={0}
                            end={statistic.normalUsers || 0}
                            duration={1}
                          />
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide className=" card card-slide">
                  <div className="card-body">
                    <div className="progress-widget">
                      <Circularprogressbar
                        stroke={variableColors.primary}
                        width="60px"
                        height="60px"
                        trailstroke="#ddd"
                        strokewidth="4px"
                        Linecap="rounded"
                        style={{ width: 60, height: 60 }}
                        value={100}
                        id="circle-progress-03"
                      >
                        <MdWorkspacePremium size={30} />
                      </Circularprogressbar>
                      <div className="progress-detail">
                        <p className="mb-2">Premium Users</p>
                        <h4 className="counter">
                          <CountUp
                            start={0}
                            end={statistic.premiumUsers}
                            duration={1}
                          />
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide className=" card card-slide">
                  <div className="card-body">
                    <div className="progress-widget">
                      <Circularprogressbar
                        stroke={variableColors.info}
                        width="60px"
                        height="60px"
                        trailstroke="#ddd"
                        strokewidth="4px"
                        Linecap="rounded"
                        style={{ width: 60, height: 60 }}
                        value={100}
                        id="circle-progress-04"
                      >
                        <TbRadioactiveFilled size={30} />
                      </Circularprogressbar>
                      <div className="progress-detail">
                        <p className="mb-2">Active Accounts</p>
                        <h4 className="counter">
                          <CountUp
                            start={0}
                            end={statistic.activeAccounts || 0}
                            duration={3}
                          />
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide className=" card card-slide">
                  <div className="card-body">
                    <div className="progress-widget">
                      <Circularprogressbar
                        stroke={variableColors.primary}
                        width="60px"
                        height="60px"
                        trailstroke="#ddd"
                        strokewidth="4px"
                        Linecap="rounded"
                        style={{ width: 60, height: 60 }}
                        value={100}
                        id="circle-progress-05"
                      >
                        <MdOutlineDeleteSweep size={30} />
                      </Circularprogressbar>
                      <div className="progress-detail">
                        <p className="mb-2">Deleted Accounts</p>
                        <h4 className="counter">
                          <CountUp
                            start={0}
                            end={statistic.deletedAccounts || 0}
                            duration={3}
                          />
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide className=" card card-slide">
                  <div className="card-body">
                    <div className="progress-widget">
                      <Circularprogressbar
                        stroke={variableColors.primary}
                        width="60px"
                        height="60px"
                        trailstroke="#ddd"
                        strokewidth="4px"
                        Linecap="rounded"
                        style={{ width: 60, height: 60 }}
                        value={100}
                        id="circle-progress-05"
                      >
                        <MdOutlineVerified size={30} />
                      </Circularprogressbar>
                      <div className="progress-detail">
                        <Popover content={"Verified Accounts"} placement="top">
                          <p className="mb-2">Verif...</p>
                        </Popover>
                        <h4 className="counter">
                          <CountUp
                            start={0}
                            end={statistic.verifiedUsers || 0}
                            duration={3}
                          />
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide className=" card card-slide">
                  <div className="card-body">
                    <div className="progress-widget">
                      <Circularprogressbar
                        stroke={variableColors.primary}
                        width="60px"
                        height="60px"
                        trailstroke="#ddd"
                        strokewidth="4px"
                        Linecap="rounded"
                        style={{ width: 60, height: 60 }}
                        value={100}
                        id="circle-progress-05"
                      >
                        <VscUnverified size={30} />
                      </Circularprogressbar>
                      <div className="progress-detail">
                        <Popover
                          placement="top"
                          content={"Under Verification Accounts"}
                        >
                          <p className="mb-2">Under Verifi...</p>
                        </Popover>
                        <h4 className="counter">
                          <CountUp
                            start={0}
                            end={statistic.underVerifiedUsers || 0}
                            duration={3}
                          />
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide className=" card card-slide">
                  <div className="card-body">
                    <div className="progress-widget">
                      <Circularprogressbar
                        stroke={variableColors.primary}
                        width="60px"
                        height="60px"
                        trailstroke="#ddd"
                        strokewidth="4px"
                        Linecap="rounded"
                        style={{ width: 60, height: 60 }}
                        value={100}
                        id="circle-progress-05"
                      >
                        <RxCrossCircled size={30} />
                      </Circularprogressbar>
                      <div className="progress-detail">
                        <Popover placement="top" content={"Not Verified Users"}>
                          <p className="mb-2">Not Verif...</p>
                        </Popover>
                        <h4 className="counter">
                          <CountUp
                            start={0}
                            end={statistic.notVerifiedUsers || 0}
                            duration={3}
                          />
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <div className="swiper-button swiper-button-next"></div>
                <div className="swiper-button swiper-button-prev"></div>
              </Swiper>
            </div>
          </Row>
        </Col>
        {/* Login IOS Android */}
        <Col md="12" lg="12">
          <Row className="row-cols-1">
            <div className="overflow-hidden d-slider1 ">
              <Swiper
                className="p-0 m-0 mb-2 list-inline "
                slidesPerView={5}
                spaceBetween={32}
                navigation={{
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                }}
                breakpoints={{
                  320: { slidesPerView: 1 },
                  550: { slidesPerView: 2 },
                  991: { slidesPerView: 3 },
                  1400: { slidesPerView: 3 },
                  1500: { slidesPerView: 4 },
                  1920: { slidesPerView: 4 },
                  2040: { slidesPerView: 7 },
                  2440: { slidesPerView: 8 },
                }}
              >
                <SwiperSlide className="card card-slide">
                  <div className="card-body">
                    <div className="progress-widget">
                      <Circularprogressbar
                        stroke={variableColors.primary}
                        width="60px"
                        height="60px"
                        Linecap="rounded"
                        trailstroke="#ddd"
                        strokewidth="4px"
                        style={{ width: 60, height: 60 }}
                        value={100}
                        id="circle-progress-01"
                      >
                        <MdOnlinePrediction size={30} />
                      </Circularprogressbar>
                      <div className="progress-detail">
                        <p className="mb-2">Loggin Users</p>
                        <h4 className="counter">
                          <CountUp
                            start={0}
                            end={statistic.logginAccounts}
                            duration={1}
                          />
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide className=" card card-slide">
                  <div className="card-body">
                    <div className="progress-widget">
                      <Circularprogressbar
                        stroke={variableColors.info}
                        width="60px"
                        height="60px"
                        trailstroke="#ddd"
                        strokewidth="4px"
                        Linecap="rounded"
                        style={{ width: 60, height: 60 }}
                        value={100}
                        id="circle-progress-02"
                      >
                        <FaApple size={30} />
                      </Circularprogressbar>
                      <div className="progress-detail">
                        <p className="mb-2">IOS Users</p>
                        <h4 className="counter">
                          <CountUp
                            start={0}
                            end={statistic.iosUsers}
                            duration={1}
                          />
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide className=" card card-slide">
                  <div className="card-body">
                    <div className="progress-widget">
                      <Circularprogressbar
                        stroke={variableColors.primary}
                        width="60px"
                        height="60px"
                        trailstroke="#ddd"
                        strokewidth="4px"
                        Linecap="rounded"
                        style={{ width: 60, height: 60 }}
                        value={100}
                        id="circle-progress-03"
                      >
                        <IoLogoAndroid size={30} />
                      </Circularprogressbar>
                      <div className="progress-detail">
                        <p className="mb-2">Android Users</p>
                        <h4 className="counter">
                          <CountUp
                            start={0}
                            end={statistic.androidusers}
                            duration={1}
                          />
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide className=" card card-slide">
                  <div className="card-body">
                    <div className="progress-widget">
                      <Circularprogressbar
                        stroke={variableColors.info}
                        width="60px"
                        height="60px"
                        trailstroke="#ddd"
                        strokewidth="4px"
                        Linecap="rounded"
                        style={{ width: 60, height: 60 }}
                        value={100}
                        id="circle-progress-04"
                      >
                        <MdReport size={30} />
                      </Circularprogressbar>
                      <div className="progress-detail">
                        <p className="mb-2">Reported Users</p>
                        <h4 className="counter">
                          <CountUp
                            start={0}
                            end={statistic.totalReport}
                            duration={1}
                          />
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide className=" card card-slide">
                  <div className="card-body">
                    <div className="progress-widget">
                      <Circularprogressbar
                        stroke={variableColors.info}
                        width="60px"
                        height="60px"
                        trailstroke="#ddd"
                        strokewidth="4px"
                        Linecap="rounded"
                        style={{ width: 60, height: 60 }}
                        value={100}
                        id="circle-progress-04"
                      >
                        <FaBan size={30} />
                      </Circularprogressbar>
                      <div className="progress-detail">
                        <p className="mb-2">Suspended Users</p>
                        <h4 className="counter">
                          <CountUp
                            start={0}
                            end={statistic.suspsendUsers}
                            duration={1}
                          />
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <div className="swiper-button swiper-button-next"></div>
                <div className="swiper-button swiper-button-prev"></div>
              </Swiper>
            </div>
          </Row>
        </Col>
        {/* User graph */}
        {/* Premium */}
        <Col md="12" lg="8">
          <Row>
            <Col style={{ width: "100%" }} md="12">
              <div className="">
                <div className="flex-wrap card-header d-flex justify-content-between">
                  <div className="header-title">
                    <h4 className="card-title">Statistics</h4>
                    <p className="mb-0"></p>
                  </div>
                </div>
                <div className="card-body">
                  {!spinner && (
                    <PieChart
                      android={statistic.androidusers}
                      ios={statistic.iosUsers}
                      normal={statistic.normalUsers}
                      premium={statistic.premiumUsers}
                    />
                  )}
                </div>
              </div>
            </Col>
          </Row>
          <Row className="d-flex justify-content-between align-items-center">
            <Col>
              <h2>Recent Users</h2>
            </Col>
            <Col className="text-end">
              <Link to="/userList">View More</Link>
            </Col>
          </Row>
          <Row>
            <Table
              dataSource={users}
              loading={loading}
              rowKey="id"
              columns={columns}
            />
          </Row>
        </Col>
      </Row>
    </Fragment>
  );
});

export default Index;
